import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container-fluid mtb15 no-fluid" }
const _hoisted_2 = { class: "row sm-gutters" }
const _hoisted_3 = {
  key: 0,
  class: "col-sm-12 col-md-2"
}
const _hoisted_4 = { class: "row align-items-center wallet-detail-header" }
const _hoisted_5 = { class: "col-sm-1 wallet-detail-back" }
const _hoisted_6 = { class: "col-sm-11 wallet-detail-title" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "order-details-loading"
}
const _hoisted_10 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_11 = { class: "table order-details-table" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppMenu = _resolveComponent("AppMenu")!
  const _component_Preloader = _resolveComponent("Preloader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (1200 < $setup.getWindowsWidth)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_AppMenu)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["col-sm-12", { 'col-md-10': 1200 < $setup.getWindowsWidth }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn btn-outline-secondary btn-light mb-2", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }]),
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.goBack()), ["prevent"]))
            }, "←", 2)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (1200 < $setup.getWindowsWidth)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_7, _toDisplayString($setup.getOrdersLabel) + " - #" + _toDisplayString($setup.orderId), 1))
              : (_openBlock(), _createElementBlock("h6", _hoisted_8, _toDisplayString($setup.getOrdersLabel) + " - #" + _toDisplayString($setup.orderId), 1))
          ])
        ]),
        (!$setup.orderDetailsLoaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_Preloader)
            ]))
          : ($setup.order)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("table", _hoisted_11, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                      }, _toDisplayString($setup.getStatusLabel), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["prop-value", [$setup.getOrderStatusClass($setup.order), { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }]])
                      }, _toDisplayString($setup.getOrderStatus($setup.order)), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                      }, _toDisplayString($setup.getOrderIdLabel), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                      }, _toDisplayString($setup.orderIdentifier), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                      }, _toDisplayString($setup.getTimestampLabel), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                      }, _toDisplayString($setup.getDate($setup.order?.acquired)), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                      }, _toDisplayString($setup.getTypeLabel), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                      }, _toDisplayString($setup.getOrderType($setup.order?.action)), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                      }, _toDisplayString($setup.getOrderTypeLabel), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                      }, _toDisplayString($setup.getPurchaseType($setup.order?.type)), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                      }, _toDisplayString($setup.getCodeLabel), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                      }, _toDisplayString($setup.order?.code), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                      }, _toDisplayString($setup.getNameLabel), 3),
                      (0 === 'BG'.localeCompare($setup.getUserLanguage))
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 0,
                            class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                          }, _toDisplayString($setup.order?.nBG ? $setup.order?.nBG : $setup.order?.nEN), 3))
                        : _createCommentVNode("", true),
                      (0 === 'EN'.localeCompare($setup.getUserLanguage))
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 1,
                            class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                          }, _toDisplayString($setup.order?.nEN), 3))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                      }, _toDisplayString($setup.getExchangeLabel), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                      }, _toDisplayString($setup.orderExchangeCode), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                      }, _toDisplayString($setup.getSegmentLabel), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                      }, _toDisplayString($setup.order?.segment), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                      }, _toDisplayString($setup.getInstrumentTypeLabel), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                      }, _toDisplayString($setup.getInstrumentType($setup.order?.stid)), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                      }, _toDisplayString($setup.getValidityLabel), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                      }, _toDisplayString($setup.getValidityDate($setup.order)), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                      }, _toDisplayString($setup.getRestrictionLabel), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                      }, _toDisplayString($setup.getRestriction($setup.order)), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                      }, _toDisplayString($setup.getTradeAtCloseLabel), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                      }, _toDisplayString($setup.getTradeAtClose($setup.order)), 3)
                    ]),
                    ($setup.hasStopPrice($setup.order))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                          _createElementVNode("td", {
                            class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                          }, _toDisplayString($setup.getStopPriceLabel), 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                          }, _toDisplayString($setup.formatOrderLimitPrice($setup.getStopPrice($setup.order))), 3)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.hasPeakAmount($setup.order))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                          _createElementVNode("td", {
                            class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                          }, _toDisplayString($setup.getPeakLabel), 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                          }, _toDisplayString($setup.formatQuantityOrFaceValue($setup.getPeakAmount($setup.order))), 3)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                      }, _toDisplayString($setup.getQuantityOrFaceValueLabel), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                      }, _toDisplayString($setup.formatQuantityOrFaceValue($setup.getQuantityOrFaceValue())), 3)
                    ]),
                    ($setup.hasLimitPrice($setup.order))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                          _createElementVNode("td", {
                            class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                          }, _toDisplayString($setup.getPriceLabel), 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                          }, _toDisplayString($setup.formatOrderLimitPrice($setup.getLimitPrice($setup.order))), 3)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.hasLimitPrice($setup.order))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                          _createElementVNode("td", {
                            class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                          }, _toDisplayString($setup.getAmountLabel), 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                          }, _toDisplayString($setup.formatPrice($setup.getOrderMoneyAmount($setup.order), $setup.order?.cc, 2)), 3)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                      }, _toDisplayString($setup.getCommissionLabel), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                      }, _toDisplayString($setup.formatPrice($setup.order?.fee, $setup.order?.cc, 2)), 3)
                    ]),
                    ($setup.hasLimitPrice($setup.order))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                          _createElementVNode("td", {
                            class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                          }, _toDisplayString($setup.getTotalAmountLabel), 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                          }, _toDisplayString($setup.formatPrice($setup.getOrderTotalAmount($setup.order), $setup.order?.cc, 2)), 3)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}